module.exports = __webpack_public_path__ + "img/ic-location.5b31144a.svg";